<template>
    <div class="daum-wrapper d-none">
        <span class="btn btn-text btn-fold-wrap" v-html="$t('button.close')"></span>
    </div>
</template>

<script setup>
</script>